import { MenuItemEnum } from '@/components/layout/sidebar/sideBarMenu/model/SideBarMenuItems.model.tsx';

export type PageTitlesTranslation = Record<MenuItemEnum, string>;

export const pageTitlesTranslation: PageTitlesTranslation = {
  [MenuItemEnum.ADMIN]: 'Admin Panel',
  [MenuItemEnum.AREA]: 'My HRBP area',
  [MenuItemEnum.CERTIFICATION]: 'Certification',
  [MenuItemEnum.CONTACT]: 'Contact',
  [MenuItemEnum.EMPLOYEE_PROFILE]: 'Individual Employee Profile',
  [MenuItemEnum.EMPLOYEE_PROFILES_SEARCH]: 'Employee search',
  [MenuItemEnum.EMPLOYEE_PROFILES_SEARCH_AI]: 'Matching employees to a position',
  [MenuItemEnum.GROUP_TRAININGS]: 'Group trainings',
  [MenuItemEnum.KNOW_ME]: 'KnowMe',
  [MenuItemEnum.NESTED_STRUCTURE]: 'Nested structure',
  [MenuItemEnum.NEWS]: 'News',
  [MenuItemEnum.NOTIFICATIONS]: 'Notifications',
  [MenuItemEnum.ORGANIZATION_CHART]: 'Organizational structure',
  [MenuItemEnum.SUCCESSION]: 'Manage succession',
  [MenuItemEnum.SUCCESSION_CHANGELOG]: 'Succession change log',
  [MenuItemEnum.TEAM]: 'My team',
  [MenuItemEnum.USERS_LIST]: 'Accounts management',
};
